// extracted by mini-css-extract-plugin
export default {"overlay":"MA-z","bodyOpen":"NA-z","content":"OA-z","header":"PA-z","close":"QA-z","closeNoHeading":"RA-z"};